export default {
  setChampionship({ commit }, championship) {
    commit("SET_CHAMPIONSHIP", championship);
  },
};
